import { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";

//Link download declarações gestor e participantes juntas
export const BOTH_DECLARATIONS =
	"https://maxmilhas.s3.amazonaws.com/regulamentos/declaracoes/Declarac%CC%A7o%CC%83es+Conta+Fam%C3%ADlia.zip";

//Link download declaração gestor
export const MANAGER_DECLARATION =
	"https://maxmilhas.s3.amazonaws.com/regulamentos/declaracoes/Declarac%CC%A7a%CC%83o+Conta+Fami%CC%81lia+Participante.pdf";

//Link download declaração participante
export const PARTICIPANT_DECLARATION =
	"https://maxmilhas.s3.amazonaws.com/regulamentos/declaracoes/Declarac%CC%A7a%CC%83o+Conta+Fami%CC%81lia+Participante.pdf";

function formatTermsContent(html) {
	if (!html) return null;
	return html
		.replace(/<ol>/g, '<ol style="list-style-type: none;">')
		.replace(
			'<p class="ql-align-center">***</p>',
			'<p style="text-align: center;">***</p>'
		)
		.replace(/<li>/g, '<li style="margin-bottom: 8px;">');
}

export function useTerms(slug) {
	const [content, setContent] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!slug) return;

		let cancelled = false;
		async function fetchTerms() {
			setLoading(true);
			try {
				const baseUrl = `${process.env.BFF_MALL_API}/my-account/term/${slug}`;

				const res = await fetch(baseUrl);

				if (!res.ok) throw new Error(`HTTP ${res.status}`)

				const json = await res.json();
				let data = formatTermsContent(json?.currentVersion?.content);

				if (!cancelled) {
					setContent(ReactHtmlParser(data));
				}
			} catch (err) {
				if (!cancelled) {
					console.error("Erro ao buscar termos:", err);
					setError(err.message);
					setContent(null);
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		}
		fetchTerms();

		return () => {
			cancelled = true;
		};
	}, [slug]);

	return { content, loading, error };
}

export function renderTermsDescription({ loading, error, content }) {
	if (loading) return <p>Carregando...</p>;
	if (error) return <p style={{ color: "red" }}>Não foi possível carregar os termos</p>;
	return content;
}
